// In-page top bar used on Dashboard. A thin row with breadcrumb-style label
// on the left and a sage live-pulse indicator on the right.
//
// Lives inside the page (not full-bleed) so it composes with the existing
// app-shell main padding. The kit's full-bleed sticky topbar is V2 work
// when search + notifications are real.

import type { ReactNode } from "react";

export type TopBarProps = {
  /** First half of the breadcrumb, e.g. "This week". */
  label: string;
  /** Right-side detail rendered after a · separator. Optional. */
  detail?: ReactNode;
  /** Live indicator on the right. Number drives the count text. */
  live?: { count: number; suffix?: string };
};

export function TopBar({ label, detail, live }: TopBarProps) {
  return (
    <div className="dashboard-topbar">
      <span className="crumb">
        <span><b>{label}</b>{detail ? <> · {detail}</> : null}</span>
        {live ? (
          <span className="live">
            <span className="live-dot" aria-hidden="true" />
            {live.count} {live.suffix ?? (live.count === 1 ? "reading" : "readings")}
          </span>
        ) : null}
      </span>
    </div>
  );
}
